export const navHeight = 64
export const footerHeight = 0
export const sideMenuWidth = 64
export const sideMenuOffset = 88
export const inputBorderRadius = 8
export const defaultPadding = 24
export const tabMinHeight = 42
export const tabMaxHeight = 42
export const viewHeaderMaxHeight = 90
export const standardTransitionDuration = 300

// 42 + 90 + 24 * 9, 42 is tab height, 90 is view header height, 24 is default padding for each element that has padding to make sure no scroller will appear
export const tabOffset = tabMaxHeight + viewHeaderMaxHeight + defaultPadding * 9
